export default __webpack_public_path__ + "static/media/comment.07cb3baa.svg";